<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Contacts-grid component
 */
export default {
  page: {
    title: "Staff Members",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "Staff Members",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Members",
          active: true,
        },
      ],
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
      existingName: [],
      existingPhone: [],
      users: {
        branch_id: "",
        name: "",
        contact: "",
        date: "",
        position: "",
        email: "",
        gender: "",
        address: "",
      },
      genderOptions: [
        {
          id: 1,
          name: "Male",
        },
        {
          id: 2,
          name: "Female",
        },
      ],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      nameError: "",
      contactError: "",
      emailError: "",
      positionError: "",
      branchError: "",
      dateError: "",
      genderError: "",
      addressError: "",
      json_fields: {
        STAFF_NAME: "staffName",
        STAFF_CONTACT: "staffContact",
        STAFF_EMAIL: "staffEmail",
        STAFF_ADDRESS: "staffAddress",
        STAFF_GENDER: "staffGenderName",
        POSITION: "position_name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("staffModule", [
      "StaffPositions",
      "StaffSaveStatus",
      "clinic_staff",
    ]),
    ...mapGetters("auth", ["user_permissions", "branch_id"]),
    ...mapGetters("branch", ["GetBranch"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.clinic_staff ? this.clinic_staff.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.clinic_staff ? this.clinic_staff.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaffPositions: "staffModule/fetchStaffPositions",
      FetchStaff: "staffModule/fetchClinicStaff",
      AddStaff: "staffModule/addClinicStaff",
      DeleteStaff: "staffModule/deleteClinicStaff",
      FetchBranch: "branch/fetchBranch",
    }),

    checkNamePhone() {
      //when creating a new one
      if (this.users.name != "" && this.users.contact != "") {
        this.existingName = this.clinic_staff.filter((staff) => {
          return staff.staffName.toUpperCase() == this.users.name.toUpperCase();
        });
        this.existingPhone = this.clinic_staff.filter((staff) => {
          return (
            staff.staffContact.toUpperCase() == this.users.contact.toUpperCase()
          );
        });
        if (this.existingName.length && this.existingPhone.length) {
          this.contactError =
            "Staff Member with this Name and Phone exists already";
        } else {
          this.existingName = [];
          this.existingPhone = [];
        }
      }
    },
    resetErrors() {
      this.nameError = "";
      this.contactError = "";
      this.emailError = "";
      this.positionError = "";
      this.branchError = "";
      this.dateError = "";
      this.genderError = "";
      this.addressError = "";
    },
    addStaff(modalId) {
      this.modal_id = modalId;
      if (this.users.name === "") {
        this.nameError = "Staff name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.users.contact === "") {
        this.contactError = "Phone Number field is required";
        return;
      } else {
        this.contactError = "";
      }
      if (this.users.gender === "") {
        this.genderError = "Gender field is required";
        return;
      } else {
        this.genderError = "";
      }
      if (this.users.address === "") {
        this.addressError = "Address field is required";
        return;
      } else {
        this.addressError = "";
      }
      if (this.users.position === "") {
        this.positionError = "Position field is required";
        return;
      } else {
        this.positionError = "";
      }
      if (this.branch_id == 0 && this.users.branch_id === "") {
        this.branchError = "Branch field is required";
        return;
      } else {
        this.branchError = "";
      }
      if (this.existingName.length && this.existingPhone.length) {
        this.contactError =
          "Staff Member with this Name and Phone exists already please";
        return;
      }
      if (!this.StaffSaveStatus) {
        this.AddStaff(this.users);
      }
    },

    resetAddStaff() {
      this.users.name = "";
      this.users.email = "";
      this.users.contact = "";
      this.users.address = "";
      this.users.gender = "";
      this.users.date = "";
      this.users.position = "";
      this.users.branch_id = "";
      this.nameError = "";
      this.emailError = "";
      this.contactError = "";
      this.dateError = "";
      this.positionError = "";
      this.genderError = "";
      this.branchError = "";
      this.addressError = "";
      this.modal_id = "";
    },

    resetDeleteStaff(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    showDeleteModal(user) {
      this.deletedata.name = user.staffName;
      this.deletedata.id = user.id;
    },
    deleteStaff(modalId) {
      this.modal_id = modalId;
      this.DeleteStaff(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStaffPositions();
    this.FetchStaff();
    this.FetchBranch();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-3">
        <download-excel
          class="btn btn-primary mb-2"
          :data="clinic_staff"
          :fields="json_fields"
          :worksheet="'STAFF MEMBERS DATA' + currentdate"
          type="csv"
          :name="'staffmemebersdata' + currentdate + '.xls'"
        >
          Export Excel <i class="fa fa-download"></i> </download-excel
        >|
        <router-link to="/staff/tabular"
          ><button class="btn btn-success mr-2 mb-2">
            <i class="fa fa-list"></i> Tabular staff view
          </button></router-link
        >
      </div>
      <div class="col-md-6"></div>
      <div v-if="user_permissions.add_staff" class="col-md-3 d-flex">
        <button class="btn btn-success ms-auto mb-2" v-b-modal.add-staff-modal>
          <i class="fa fa-plus"></i> Add Staff
        </button>
      </div>
    </div>
    <b-modal
      id="add-staff-modal"
      @hidden="resetAddStaff"
      title="Add New Staff Member"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3" v-if="branch_id == 0">
            <label>Select Branch</label>
            <select
              placeholder="Select Branch"
              v-model="users.branch_id"
              class="form-control"
            >
              <option v-for="item in GetBranch" :value="item.Id" :key="item.Id">
                {{ item.branchName }}
              </option>
            </select>
            <div class="text-danger" v-if="branchError">
              <em>{{ branchError }}</em>
            </div>
          </div>
          <div class="mb-3">
            <label for="name">Staff Name</label>
            <input
              id="name"
              v-model="users.name"
              type="text"
              class="form-control"
              placeholder="Insert name"
              @input="resetErrors()"
            />
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Contact</label>
            <input
              id="name"
              v-model="users.contact"
              type="number"
              class="form-control"
              placeholder="Insert contact"
              @input="resetErrors()"
            />
            <div class="text-danger" v-if="contactError">
              <em>{{ contactError }}</em>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label>Email</label>
            <input
              v-model="users.email"
              type="email"
              class="form-control"
              placeholder="Enter Email Address"
              @input="resetErrors()"
            />
            <div class="text-danger" v-if="emailError">
              <em>{{ emailError }}</em>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label for="date">Date Of Birth</label>
            <input
              id="date"
              v-model="users.date"
              type="date"
              class="form-control"
              placeholder="Insert date of birth"
              @input="resetErrors()"
            />
            <div class="text-danger" v-if="dateError">
              <em>{{ dateError }}</em>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label>Gender</label>
            <model-list-select
              :list="genderOptions ? genderOptions : []"
              v-model="users.gender"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Gender"
              @input="resetErrors()"
            >
            </model-list-select>
            <div class="text-danger" v-if="genderError">
              <em>{{ genderError }}</em>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label>Home Address</label>
            <input
              v-model="users.address"
              type="text"
              class="form-control"
              placeholder="Enter Staff Address"
              @input="resetErrors()"
            />
          </div>
          <div class="text-danger" v-if="addressError">
            <em>{{ addressError }}</em>
          </div>
        </div>
        <div class="col-12">
          <label>Position</label>
          <model-list-select
            :list="StaffPositions ? StaffPositions : []"
            v-model="users.position"
            option-value="id"
            option-text="positionName"
            class="mb-3"
            placeholder="Select Staff Position"
            @input="resetErrors()"
          >
          </model-list-select>
          <div class="text-danger" v-if="positionError">
            <em>{{ positionError }}</em>
          </div>
        </div>
      </div>
      <div class="text-end mt-3">
        <b-button variant="danger" @click="closeModal('add-staff-modal')"
          ><i class="fa fa-times"></i> Close</b-button
        >
        <b-button
          @click="addStaff('add-staff-modal')"
          type="submit"
          variant="success"
          class="ms-1"
        >
          Submit
          <b-spinner
            v-if="StaffSaveStatus"
            variant="light"
            small
            role="status"
          ></b-spinner>
          <i v-else class="fa fa-check"></i>
        </b-button>
      </div>
    </b-modal>
    <div class="row">
      <div
        v-for="user in clinic_staff"
        :key="user.id"
        class="col-xl-3 col-sm-6"
      >
        <div class="card text-center">
          <div class="card-body">
            <div v-if="!user.image" class="avatar-sm mx-auto mb-4">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft bg-primary
                  text-primary
                  font-size-16
                "
                >{{ user.staffName.charAt(0) }}</span
              >
            </div>
            <div v-if="user.image" class="mb-4">
              <img
                class="rounded-circle avatar-sm"
                :src="`${user.image}`"
                alt
              />
            </div>
            <h5 class="font-size-15 mb-1">
              <a href="javascript: void(0);" class="text-dark">{{
                user.staffName
              }}</a>
            </h5>
            <p class="text-muted">{{ user.position.position_name }}</p>
          </div>
          <div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill">
                <a
                  v-if="
                    user.type != 0 &&
                    user.id != user.loggedin &&
                    user_permissions.delete_staff
                  "
                  class="btn btn-danger btn-sm text-light"
                  v-b-modal.delete-staff-modal
                  @click="showDeleteModal(user)"
                >
                  <i class="fa fa-trash text-light"></i>
                  Delete
                </a>
              </div>
              <div class="flex-fill"></div>
              <div
                class="flex-fill"
                v-if="
                  user_permissions.staff_profile ||
                  user_permissions.enroll_staff ||
                  user_permissions.edit_staff
                "
              >
                <router-link
                  :to="{
                    name: 'StaffProfile',
                    params: { staff: user.id },
                  }"
                >
                  <button class="btn btn-primary btn-sm">
                    <i class="fa fa-eye text-light"></i> Details
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <!-- modal delete staff starts -->
    <b-modal id="delete-staff-modal" hide-footer @hidden="resetDeleteStaff">
      <template #modal-title>
        <h4 class="text-danger">
          Delete Staff {{ deletedata.name }}
        </h4></template
      >
      <h5>Do you want to delete this staff? Click Proceed Button to delete.</h5>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-staff-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteStaff('delete-staff-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="StaffSaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <div class="row">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-success">
            <i class="bx bx-hourglass bx-spin me-2"></i> Load more
          </a>
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
  </Layout>
</template>
